import printJS, { PrintTypes } from "print-js";
import { IBlobResponse } from "../resources-vue/vue-interfaces/i-hospice-client";
export class PrintService {
    public print(file: IBlobResponse) {
        let fileName = this.extractFileNameFromResponseHeader(file);
        let pdfFile = new Blob([file.body], {
            type: "application/pdf"
        });
        let pdfUrl = URL.createObjectURL(pdfFile);
        printJS({
            printable: pdfUrl,
            documentTitle: fileName
        });
    }

    private extractFileNameFromResponseHeader(response: IBlobResponse): string {
        let responseHeader: string = response.headers.get("content-disposition");
        return responseHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
    }
}
